var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsNumber, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { NotificationFullSizeDto } from '../../notification/dto/notification.full-size.dto.js';
import { OfficeProductAssignmentFullSizeDto } from '../../office-products/dtos/office-product-assignment.full-size.dto.js';
import { Role } from '../../roles/enums/role.enum.js';
import { UserProfileDto } from '../../user/dto/user.profile.dto.js';
import { TreatmentLocation } from '../enums/treatment-location.enum.js';
import { CallPatientLiteDto } from './call-patient.lite.dto.js';
export class CallFullSizeDto {
    id;
    createdAt;
    updatedAt;
    deletedAt;
    /** @deprecated Use the linked Appointment's therapistId instead. */
    therapistId;
    /** @deprecated Use the linked Appointment's scheduledStart instead. */
    scheduledStart;
    /** @deprecated Use the linked Appointment's service instead. */
    service;
    /** @deprecated Use the linked Appointment's description instead. */
    description;
    /** @deprecated Use the linked Appointment's plannedDuration instead. */
    plannedDuration;
    isCanceled;
    isInitialized;
    initializationTime;
    hasEnded;
    /** @deprecated Use the linked Appointment's treatmentLocation instead. */
    treatmentLocation;
    isProposed;
    callPatients;
    therapist;
    /** @deprecated Use the linked Appointment's officeLocationId instead. */
    officeLocationId;
    /** @deprecated Use the linked Appointment's officeLocation instead. */
    officeLocation;
    notifications;
    index;
    archiveDownloadTimestamp;
    expiresInDays;
    // call-meta
    endedByTherapistOn;
    /** @deprecated Use the linked Appointment's officeProductAssignmentId instead. */
    officeProductAssignmentId;
    /** @deprecated Use the linked Appointment's officeProductAssignment instead. */
    officeProductAssignment;
    appointmentId;
    declines = 0;
    isDeclined = false;
    acceptations = 0;
    isAccepted = false;
    isPartiallyAccepted = false;
    pendings = 0;
    isPending = false;
    get therapistOfficeId() {
        return this.therapist?.officeId;
    }
    get patientIds() {
        return this.callPatients
            ? this.callPatients.map((callPatient) => callPatient?.patient?.id || '')
            : [];
    }
    get totalPatients() {
        return this.callPatients?.length || 0;
    }
    get isDone() {
        return this.scheduledStart < new Date();
    }
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], CallFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], CallFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], CallFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Object)
], CallFullSizeDto.prototype, "deletedAt", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CallFullSizeDto.prototype, "therapistId", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], CallFullSizeDto.prototype, "scheduledStart", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], CallFullSizeDto.prototype, "service", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CallFullSizeDto.prototype, "description", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], CallFullSizeDto.prototype, "plannedDuration", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Boolean)
], CallFullSizeDto.prototype, "isCanceled", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Boolean)
], CallFullSizeDto.prototype, "isInitialized", void 0);
__decorate([
    IsDateString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CallFullSizeDto.prototype, "initializationTime", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Boolean)
], CallFullSizeDto.prototype, "hasEnded", void 0);
__decorate([
    IsEnum(TreatmentLocation),
    Expose(),
    __metadata("design:type", String)
], CallFullSizeDto.prototype, "treatmentLocation", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Boolean)
], CallFullSizeDto.prototype, "isProposed", void 0);
__decorate([
    IsArray(),
    Type(() => CallPatientLiteDto),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Array)
], CallFullSizeDto.prototype, "callPatients", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", Function)
], CallFullSizeDto.prototype, "therapist", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    Expose(),
    __metadata("design:type", Object)
], CallFullSizeDto.prototype, "officeLocationId", void 0);
__decorate([
    IsOptional(),
    IsObject(),
    Expose(),
    __metadata("design:type", Object)
], CallFullSizeDto.prototype, "officeLocation", void 0);
__decorate([
    IsArray(),
    Type(() => NotificationFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], CallFullSizeDto.prototype, "notifications", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Number)
], CallFullSizeDto.prototype, "index", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", Object)
], CallFullSizeDto.prototype, "archiveDownloadTimestamp", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], CallFullSizeDto.prototype, "expiresInDays", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    IsOptional(),
    __metadata("design:type", Object)
], CallFullSizeDto.prototype, "endedByTherapistOn", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], CallFullSizeDto.prototype, "officeProductAssignmentId", void 0);
__decorate([
    IsObject(),
    IsOptional(),
    Expose(),
    Type(() => OfficeProductAssignmentFullSizeDto),
    __metadata("design:type", Object)
], CallFullSizeDto.prototype, "officeProductAssignment", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], CallFullSizeDto.prototype, "appointmentId", void 0);
__decorate([
    IsNumber(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Number)
], CallFullSizeDto.prototype, "declines", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Boolean)
], CallFullSizeDto.prototype, "isDeclined", void 0);
__decorate([
    IsNumber(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Number)
], CallFullSizeDto.prototype, "acceptations", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Boolean)
], CallFullSizeDto.prototype, "isAccepted", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Boolean)
], CallFullSizeDto.prototype, "isPartiallyAccepted", void 0);
__decorate([
    IsNumber(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Number)
], CallFullSizeDto.prototype, "pendings", void 0);
__decorate([
    IsBoolean(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Boolean)
], CallFullSizeDto.prototype, "isPending", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], CallFullSizeDto.prototype, "therapistOfficeId", null);
__decorate([
    IsArray(),
    IsString({ each: true }),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], CallFullSizeDto.prototype, "patientIds", null);
__decorate([
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    IsNumber(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], CallFullSizeDto.prototype, "totalPatients", null);
__decorate([
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.THERAPIST] }),
    IsBoolean(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], CallFullSizeDto.prototype, "isDone", null);
//# sourceMappingURL=call.full-size.dto.js.map